import React from "react";
import { _common } from "../common";
const common = _common;

export default function PlatzbelegungPage2(props: {}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "100%",
        gap: "10px",
        overflow: "hidden",
        backgroundColor: "white",
        borderRadius: "10px",
        border: "1px solid grey",
      }}
    >
      <iframe style={{ width: "100%", height: "100%" }} src={common.PlatzbelegungPage2Src} />;
    </div>
  );
}
